import { SVGProps, Ref, forwardRef } from 'react';

export const UturnRightOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="m9.68 1.49.99-.99 4.833 4.833-4.833 4.834-.99-.99 3.143-3.144H5.935a4.035 4.035 0 0 0 0 8.07H14v1.4H5.935a5.435 5.435 0 1 1 0-10.87h6.888z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
UturnRightOutlinedSize16Glyph.displayName = 'UturnRightOutlinedSize16Glyph';
